// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1xhKY","title":"Header_title__2a81j","side":"Header_side__1_SuA"};